export function resolveEditableTarget(target) {
    if (!target) return null
    if (typeof target.closest === "function") {
        const editable = target.closest("[contenteditable='true']")
        if (editable) {
            return { type: "contenteditable", element: editable }
        }
    }
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        if (target.disabled || target.readOnly) return null
        return { type: "input", element: target }
    }
    return null
}

export function resolveEditableInput(editable) {
    if (!editable) return { value: "", cursorIndex: 0 }
    if (editable.type === "input") {
        return {
            value: editable.element.value ?? "",
            cursorIndex: Number.isFinite(editable.element.selectionStart) ? editable.element.selectionStart : 0,
        }
    }
    return resolveContentEditableInput(editable.element)
}

export function resolveContentEditableInput(element) {
    const selection = window.getSelection()
    if (!selection || selection.rangeCount === 0) return { value: "", cursorIndex: 0 }
    const range = selection.getRangeAt(0)
    if (!element.contains(range.startContainer)) return { value: "", cursorIndex: 0 }
    if (range.startContainer.nodeType !== Node.TEXT_NODE) {
        return { value: "", cursorIndex: 0 }
    }
    const text = range.startContainer.nodeValue ?? ""
    return { value: text, cursorIndex: range.startOffset }
}

export function getContentEditableCursor(element) {
    const selection = window.getSelection()
    if (!selection || selection.rangeCount === 0) return 0
    const range = selection.getRangeAt(0)
    if (!element.contains(range.startContainer)) return 0
    const preRange = range.cloneRange()
    preRange.selectNodeContents(element)
    preRange.setEnd(range.startContainer, range.startOffset)
    return preRange.cloneContents().textContent?.length ?? 0
}
